export const BASE_URL = process.env.NODE_ENV === 'development' ? '' : '/atlaskit/registry';
export const STORY_BASE_URL = 'https://aui-cdn.atlassian.com/atlaskit/stories';

export const TABS = [
  {
    title: 'All components',
    filter: () => true,
  },
  {
    title: 'AtlasKit',
    filter: (component) => {
      return component.keywords.indexOf('atlaskit') > -1;
    },
  },
  {
    title: 'Fabric',
    filter: (component) => {
      return component.keywords.indexOf('fabric') > -1;
    },
  },
  {
    title: 'Media',
    filter: (component) => {
      return component.keywords.indexOf('media') > -1;
    },
  }
];

// val: 1485733189426
// lwk: 1485921438710



// WEBPACK FOOTER //
// ./src/config.js